export enum FunctionsTypes {
  LOCATIONS_LIST = 'Search_locations',
  SPECIALTIES_LIST = 'Search_specialties',
  SEARCH_SCHEDULES = 'Search_schedules',
  SEARCH_SCHEDULE_SLOT = 'Search_Schedule_slot',
  SEARCH_CALENDAR = 'Search_calendars',
  BOOK_APPOINTMENT = 'Search_book',
  APPOINTMENTS_READ = 'Appointments_read',
  APPOINTMENTS_LIST = 'Appointments_list',
  APPOINTMENTS_HISTORY_LIST = 'Appointments_History_list',
  APPOINTMENTS_UPDATE = 'Appointments_update',
  ORGANIZATIONS_LIST = 'Search_organizations',
  AUTH_GET_CAPTCHA = 'Auth_getCaptcha',
  AUTH_REGISTER_VERIFY = 'Auth_Verify_sendVerificationCode',
  AUTH_VERIFY_IDENTIFIER = 'Auth_Verify_Identifier',
  AUTH_VERIFY_EMAIL = 'Auth_Verify_Email',
  AUTH_EMAIL_EDIT = 'Auth_Email_edit',
  AUTH_EMAIL_SEND = 'Auth_Email_sendVerification',
  AUTH_EMAIL_VERIFY = 'Auth_Email_verify',
  AUTH_REGISTER = 'Auth_register',
  PATIENT_UPDATE = 'Patient_update',
  RELATED_ADD = 'RelatedPatient_add',
  RELATED_UPDATE = 'RelatedPatient_update',
  SEARCH_PRACTITIONER = 'Search_practitioner',
  ONDEMAND_TELEDOC = 'OnDemand_Teledoc_getLink',
  FAVORITE_ADD = 'Patient_Favorite_add',
  FAVORITE_REMOVE = 'Patient_Favorite_remove',
  PATIENT_CONFIG = 'Patient_Config_accelerate',
  PRACTITIONERS_LIST = 'Practitioners_list',
  FONASA_VOUCHER_CREATE = 'Fonasa_Voucher_create',
  FONASA_VOUCHER_CANCEL = 'Fonasa_Voucher_cancel',
  FONASA_VOUCHER_GET = 'Fonasa_Voucher_get',
  FONASA_VOUCHER_LIST = 'Fonasa_Voucher_list',
  FONASA_VOUCHER_PAY = 'Fonasa_Voucher_pay',
  BENEFITS_ASSIGN = 'Benefits_Assign',
  BENEFITS_FUNCTION = 'Benefits_Function'
}
